export const KAMERA_SUNUCU = 'http://107.151.198.98:31749';

export const DEFAULT_KAMERALAR = {
  lokasyonlar: {
    hadimkoy: {
      ad: 'Hadımköy',
      ic: [
        { id: 1,  ad: 'Büyük Atölye (Sarı Bina)',  uuid: '' },
        { id: 2,  ad: 'Kaynak Atölyesi 1',          uuid: '' },
        { id: 3,  ad: 'Kaynak Atölyesi 2',          uuid: '' },
        { id: 4,  ad: 'Kaynak Atölyesi 3',          uuid: '' },
        { id: 5,  ad: 'Açık Atölye 1',              uuid: '' },
        { id: 6,  ad: 'Açık Atölye 2',              uuid: '' },
        { id: 7,  ad: 'Kaporta 1',                  uuid: '' },
        { id: 8,  ad: 'Kaporta 2',                  uuid: '' },
        { id: 9,  ad: 'Kaporta 3',                  uuid: '' },
        { id: 10, ad: 'Kaporta 4',                  uuid: '' },
        { id: 11, ad: 'Boyahane 1',                 uuid: '' },
        { id: 12, ad: 'Boyahane 2',                 uuid: '' },
        { id: 13, ad: 'Boyahane 3',                 uuid: '' },
        { id: 14, ad: 'Şasi 1',                     uuid: '' },
        { id: 15, ad: 'Şasi 2',                     uuid: '' },
        { id: 16, ad: 'Şasi 3',                     uuid: '' },
        { id: 17, ad: 'Fren 1',                     uuid: '' },
        { id: 18, ad: 'Fren 2',                     uuid: '' },
        { id: 19, ad: 'Fren 3',                     uuid: '' },
      ],
      dis: [
        { id: 1,  ad: 'Ön Kapı',          uuid: '082047BB-640E-6fe6-65E1-1E5978EA29EE' },
        { id: 2,  ad: 'Arsa Genel 1',     uuid: '' },
        { id: 3,  ad: 'Atölye Ön',        uuid: '' },
        { id: 4,  ad: 'Atölye Kapılar',   uuid: '' },
        { id: 5,  ad: 'Arsa Genel 2',     uuid: '' },
        { id: 6,  ad: 'Şase Ön',          uuid: '' },
        { id: 7,  ad: 'Fren Ön',          uuid: '' },
        { id: 8,  ad: 'Yan Arsa',         uuid: '' },
        { id: 9,  ad: 'Fren Yan Taraf 1', uuid: '' },
        { id: 10, ad: 'Fren Yan Taraf 2', uuid: '' },
        { id: 11, ad: 'Fren Yan Taraf 3', uuid: '' },
        { id: 12, ad: 'Fren Yan Taraf 4', uuid: '' },
        { id: 13, ad: 'Sınır 1',          uuid: '' },
        { id: 14, ad: 'Tekne',            uuid: '' },
        { id: 15, ad: 'Mescit',           uuid: '' },
      ],
    },
    ikitelli: {
      ad: 'İkitelli',
      ic: [
        { id: 1,  ad: 'İç Kamera 1',  uuid: '' },
        { id: 2,  ad: 'İç Kamera 2',  uuid: '' },
        { id: 3,  ad: 'İç Kamera 3',  uuid: '' },
        { id: 4,  ad: 'İç Kamera 4',  uuid: '' },
        { id: 5,  ad: 'İç Kamera 5',  uuid: '' },
      ],
      dis: [
        { id: 1, ad: 'Dış Kamera 1', uuid: '' },
        { id: 2, ad: 'Dış Kamera 2', uuid: '' },
        { id: 3, ad: 'Dış Kamera 3', uuid: '' },
      ],
    },
  }
};

